/**
 * Every — the minutes between two drops on the clock, with the usual paces
 * one click away. Shown in Schedule and again atop Drop slots (20/10/2026),
 * the same field in both.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { Timer } from 'lucide-react';

import type { ContainerEditor } from '../../state/useContainerEditor';
import { NumberStepper } from '../controls/NumberStepper';
import { StepRow } from '../controls/StepRow';

const PRESETS = [15, 30, 45, 60] as const;
const HINT = 'Minutes between two drops on the clock. A pinned drop keeps its own time.';

export const EveryRow: FC<{ editor: ContainerEditor; hint?: string }> = ({ editor, hint = HINT }) => (
  <StepRow icon={Timer} label="Every" hint={hint}>
    <NumberStepper
      value={editor.draft.intervalMin}
      onChange={(v) => editor.setField('intervalMin', v)}
      min={1}
      max={1440}
      step={5}
      ariaLabel="Minutes between drops"
      presets={PRESETS}
    />
  </StepRow>
);
